import React from 'react'
// import { useStaticQuery, graphql } from "gatsby"
import styled from 'styled-components'
import Theme from '../../vars/ThemeOptions'
 

let Styled = {};
Styled.Wrap = styled.div`
  // margin-left: 2rem;
  height: 100%;
  
  a {
    color: ${({ headCtaColor }) => headCtaColor ? headCtaColor : Theme.hex('primary')};
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
    height: 100%;
    width: 600px;
    :hover {
      text-decoration: none;
    }
    h2, p {
      margin-bottom: 0;
      white-space: nowrap;
    }
    h2 {
      font-size: 1.5rem;  
      letter-spacing: 1.3px;    
    }
    p {
      font-size: .8rem; 
      letter-spacing: .7px;     
    }
    .left-text, .right-text {
      text-align: center;
    }
    .divider {
      height: 32px;
      width: 2px;
      background: ${Theme.hex('primary')};
      margin: 0 10px;
    }
  }
  @media only screen and (max-width: 750px) {
    margin-top: 1rem;
    a {
      width: 80vw;
      h2 {
        font-size: 3vw;  
        letter-spacing: 1.3px;    
      }
      p {
        font-size: 1.5vw; 
        letter-spacing: .7px;     
      }
    }
  }
`
 
const HeadCTA = ({ headCtaColor, ctaRegion }) => {
  // const data = useStaticQuery(graphql`
  //   query {
  //     headCta: contentfulAsset(title: {eq: "Header CTA - call 3033238578 or go to coloradosidingrepair.com to get a free no pressure quote"}) {
  //       title
  //       fluid {
  //         ...GatsbyContentfulFluid
  //       }
  //       file {
  //         url
  //       }
  //     }
  //   }
  // `)
// console.log("logo: ", logo)
// const { headCta } = data ? data : null
// const { fluid } = headCta ? headCta : null
  return (
    <Styled.Wrap headCtaColor={headCtaColor}>
      <a href={'https://www.coloradosidingrepair.com/schedule-appointment/'} target="_blank" rel="noreferrer noopener">
        {/* <Img fluid={fluid} alt={headCta.title} /> */}
        {/* <img src={headCta.file.url} alt={headCta.title} /> */}
        <div className="left-text">
          <h2>FREE NO-PRESSURE QUOTE</h2>
          <p>Send us pics of your siding project via text or web</p>
        </div>
        <div className="divider" />
        <div className="right-text">
          <h2>{ctaRegion === "northern-colorado" ? '(970) 818-3050' : '(303) 323-8578'}</h2>
          <p>coloradosidingrepair.com</p>
        </div>
      </a>
    </Styled.Wrap>
  )
}

export default HeadCTA